import OfferDetail from '@/views/Portal/OfferDetail.vue';
import { Route } from '../../route.model';

const portalOfferDetail = new Route(
  '/portal/offer-detail/:id',
  'portal-offer-detail',
  OfferDetail,
  {
    requiresAuth: true,
    isResponsive: true,
    zendesk: {
      disabled: true
    }
  }
);

export { portalOfferDetail };
export default portalOfferDetail;
